'use client';

import { useMemo } from 'react';
import { useCategoriesForBrandQuery } from '../gql/queries/generated/CategoriesForBrand';

export type Category = {
  category: string;
  type: string;
};

type UseCategoriesForBrandArgs = {
  accountId: string | undefined;
  /** Brand `libraryUrn` from `Account.brands`. */
  brandId: string | null;
};

type UseCategoriesForBrandReturn = {
  categories: Category[];
  error: boolean;
  loading: boolean;
};

export function useCategoriesForBrand({
  accountId,
  brandId,
}: UseCategoriesForBrandArgs): UseCategoriesForBrandReturn {
  const { data, error, loading } = useCategoriesForBrandQuery({
    skip: !accountId || !brandId,
    variables: accountId && brandId ? { accountId, brandId } : undefined,
  });

  const categories = useMemo<Category[]>(
    () =>
      (data?.categoriesForBrand ?? []).flatMap((c) =>
        c.category != null && c.type != null
          ? [{ category: c.category, type: c.type }]
          : []
      ),
    [data]
  );

  return {
    categories,
    error: Boolean(error),
    loading: Boolean(accountId && brandId) && loading,
  };
}
